var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.164551,
    y: 0.0572033,
    width: 42.5227,
    height: 42.5523,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_31_97",
    transform: "matrix(0.0104239 0 0 0.0104167 -0.000347131 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_31_97",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADbElEQVR4nO2dv04UURTGfxEMBWDsLLSywT+8A4n4BjRWUNkQkLgNBRZWFgLyLGpQY8crCCY+AAmE0AgkhCU4ZpJDQpYs7N57d767O+eXnGQDO3O/75w7d2bu3MyC4ziO4ziO4ziO4ziO43TOU+ATsAOcAMWAxwmwDawDT5Qd5S6wAZxnkJRCFOdWiGFF8r9nkIAik/hWdRE2MjBdZBblkVDZmF/nYadoE2VOJqoogPd+2hZhrYoC7GTQ24pMo7w66jnHGRgtMo2jKgpwm4hBp1D7lwsQI/cvFyBG7l8uQIzcv1yAGLl/uQAxcv9yAWLk/uUCxMj9ywWIkfuXCxAj9y8XIEbuXy5AjNy/QsB9YAb4AGwCf4A94NRiz/62ad+ZsW16QW0KMALMAT+BZgfttkbTtp2zfaVi4AswCrwD9gOS3i72bZ+jfeBfKmAW2E2Y+NbYtTZy9S8T8AD43MPEt8YP4GFG/qUCpoCDCpN/GQfWttq/VMDrwBNsqmiaBpX/IFIJWAb+CZN/Nd4L/AeTQkAjcuXBEvDcrmpG7fOS/S90v40K/UcRK+AVcBGQoDNgHrhzw76HgAX7brf7vzBtvfYfTYyAF4HJObNtO2W6h+30bQEeAYeBw8N8gM7FwLYOTWtq/8kIEVAODVuBCdm27btlKGIV39YNbfZlAVYCE1HYyTWUtxHtriT0n5RuBTy2GcvQRDyL0DoZ0e6paY/1n5xuBXyNSEIBjEVoHY9s+0sC/31fgPEIrfe8AD4EJSfkEPSTcE0vQ38Htjlwl6GxN2ILATrfBLY1kDdiKaYiprvQ+DJwmnugpyJSTMYt3jIcDVnPD0l+LSbjUkxH79gd7qTdI4zZ50bEmF+r6ehLlv2BjLYAJf5IMoDUh+CUP5TXFqDEl6V0QS9PQrO+MEtbgBJfmpjJZdiIL87VFuAqvjw9pxsRMXL/cgFi5P7lAsTI/csFiJH7lwsQI/cvFyBG7l8uQIzcv1yAGLl/uQAxcv9yAWLk/uUCxMj9ywWIkfs/6kBEXeNvFQXwVxfTtgC/qijAegY9rcg0PlZRgPJnO/z19VxLfrOq19eX+FHAtQKsUiHD9nIk9SFfZBKbit+RGbYjoc7D0bn1/MqT33pOWLN1/HX4bYFj87pa5ZjvOI7jOI7jOI7jOI7j0Pf8BzFyJUdpkVWUAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.98b709aa49634c0632dd3b0e6a78ee77.svg";
export { ForwardRef as ReactComponent };